const CMS_API_BASE_URL = "/cms";

export const CMS_API_ENDPOINTS = {
  PAGES: `${CMS_API_BASE_URL}/pages`,
  PAGE_BY_CODE: (code: string) => `${CMS_API_BASE_URL}/pages/${code}`,
} as const;
